import React, { useState } from 'react';
import LoginForm from './LoginForm';
import ProtectedPage from './App2';
import { BrowserRouter } from 'react-router-dom';


const App = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));

    const handleLoginSuccess = () => {
        setIsAuthenticated(true);
    };

    return (
      <BrowserRouter>

        <div>
            {!isAuthenticated ? (
                <LoginForm onLoginSuccess={handleLoginSuccess} />
            ) : (
                <ProtectedPage />
            )}
        </div>
        </BrowserRouter>
    );
};

export default App;
